import { useMemo, useState, type FormEvent } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, ApiRequestError } from "../api/client";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get("token") ?? "", [params]);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!token) {
      setError("パスワード再設定URLが不正です。");
      return;
    }
    if (password.length < 8) {
      setError("パスワードは8文字以上で入力してください。");
      return;
    }
    if (password !== confirm) {
      setError("確認用パスワードが一致しません。");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.post(`/api/auth/password-reset/${encodeURIComponent(token)}`, { password });
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiRequestError ? err.message : "パスワード再設定に失敗しました。");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="auth-page">
      <section className="auth-card">
        <span className="lp-section-kicker">PASSWORD RESET</span>
        <h1>パスワード再設定</h1>
        {done ? (
          <>
            <p>パスワードを再設定しました。新しいパスワードでログインしてください。</p>
            <button className="btn btn-primary btn-block" type="button" onClick={() => navigate("/login")}>
              ログインへ
            </button>
          </>
        ) : (
          <form onSubmit={submit}>
            {error && <div className="alert alert-error">{error}</div>}
            <label>
              新しいパスワード
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
            </label>
            <label>
              新しいパスワード（確認）
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
            </label>
            <button className="btn btn-primary btn-block" type="submit" disabled={busy}>
              {busy ? "再設定中..." : "パスワードを再設定する"}
            </button>
          </form>
        )}
        <p className="auth-sub">
          <Link to="/login">ログイン画面へ戻る</Link>
        </p>
      </section>
    </main>
  );
}
